module.exports = __webpack_public_path__ + "static/media/Tornado.b367904c.png";